import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { BrowserModule } from '@angular/platform-browser';
import { BaseChartDirective } from "ng2-charts";
import { NWMControls } from 'app/components/Controls/NWMControls.module';
import { PgfIntroComponent } from './pgf-intro.component';
import { PgfResourcesComponent } from "./pgf-resources.component";
import { PgfPieComponent } from './pie/pie.component';
import { PgfHowItWorksComponent } from './how-it-works/how-it-works.component';
import { SharedModule } from "app/modules/shared/shared.module";

@NgModule({
    imports: [
        RouterModule,
        BrowserModule,
        NWMControls,
        NgbModule,
        BaseChartDirective,
        FormsModule,
        SharedModule.forRoot(),
        PgfIntroComponent,
        PgfResourcesComponent,
        PgfPieComponent,
        PgfHowItWorksComponent,
    ],
    providers: []
})
export class PgfIntroModule { }
